<template>
  <a-modal
    title="메세지 전송"
    okText="전송"
    cancelText="취소"
    @ok="onSend"
    :visible="true"
    @cancel="onClose"
  >
    <a-spin tip="로딩 중..." :spinning="isLoading">
      <a-checkbox
        :indeterminate="messages.length !== checklist.length && checklist.length > 0"
        :checked="messages.length === checklist.length"
        @change="onCheckboxAll"
      >전체 선택</a-checkbox>
      <a-row>
        <a-col :span="24" v-for="message in messages" :key="message.idx">
          <a-checkbox
            :checked="checklist.includes(message.wholesale.idx)"
            @click="onCheckbox(message.wholesale.idx)"
          >
            {{
            `${message.wholesale.name}&nbsp;
            (${message.wholesale.location.building}&nbsp;
            ${message.wholesale.location.mall}&nbsp;
            ${message.wholesale.location.floor}층&nbsp;
            ${message.wholesale.location.row}열&nbsp;
            ${message.wholesale.location.place}호)`
            }}
            <a-badge :count="message.saibs" />
          </a-checkbox>
        </a-col>
      </a-row>
    </a-spin>
  </a-modal>
</template>
<script>
import config from "../../config";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import OPCODE from "../../libs/OPCODE";
import Axios from "axios";
import { TYPES } from "../../stores/uncle";
import { mapMutations } from "vuex";
export default {
  name: "WholesaleMessage",
  data() {
    this.onLoad();
    return {
      isLoading: false,
      messages: [],
      checklist: []
    };
  },
  methods: {
    ...mapMutations([TYPES.UNCLE_SEND_MESSAGE]),
    async onLoad() {
      this.isLoading = true;
      try {
        const { data } = await Axios.get(
          `${config.hostname}/v1/uncle/saib/sending`,
          {
            withCredentials: true
          }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.messages = data.messages;
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "오류가 발생했습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "인터넷 상태를 확인해주세요."
        });
      }
      this.isLoading = false;
    },
    async onSend() {
      this.isLoading = true;
      try {
        const { data } = await Axios.post(
          `${config.hostname}/v1/uncle/saib/sending`,
          { messages: this.checklist },
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.onClose();
              config.alert.mixin({
                type: "success",
                title: "성공적으로 전송하였습니다."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "오류가 발생했습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "인터넷 상태를 확인해주세요."
        });
      }
      this.isLoading = false;
    },
    onCheckboxAll() {
      const len = this.checklist.length;
      this.checklist = [];

      if (len <= 0) {
        this.messages.forEach(({ wholesale: { idx } }) =>
          this.checklist.push(idx)
        );
      }
    },
    onCheckbox(idx) {
      if (this.checklist.includes(idx)) {
        const bak = this.checklist;
        this.checklist = [];
        for (const item of bak) {
          if (item === idx) continue;
          this.checklist.push(item);
        }
      } else {
        this.checklist.push(idx);
      }
    },
    onClose() {
      this[TYPES.UNCLE_SEND_MESSAGE](false);
    }
  }
};
</script>